import { LoadingOutlined } from '@ant-design/icons';
import { Spin, ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#22817a',
    colorInfo: '#22817a',
    fontFamily: 'OrkneyRegular',
    controlOutlineWidth: 1,
    paddingXXS: 12,
    colorText: '#1A1C21',
    colorPrimaryBg: '#eeeeee'
  }
};

export const configAnt = () => {
  Spin.setDefaultIndicator(<LoadingOutlined />);
};

export const darkVariant = {
  colorPrimary: '#1A1C21',
  colorPrimaryBg: '#5b5e61',
  colorPrimaryBgHover: '#4f5154',
  colorPrimaryBorder: '#434547',
  colorPrimaryBorderHover: '#37383b',
  colorPrimaryHover: '#2b2c2e',
  colorPrimaryActive: '#000000',
  colorPrimaryTextHover: '#2b2c2e',
  colorPrimaryText: '#1a1c21',
  colorPrimaryTextActive: '#000000',
  colorText: '#1A1C21',
  colorLink: '#1A1C21',
  colorLinkHover: '#2b2c2e',
  colorLinkActive: '#000000'
};
